module.exports = __webpack_public_path__ + "img/network-nodes.4c7f77ee.svg";